export default __webpack_public_path__ + "static/media/quantity-cv.052a172e.svg";